import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  AdminRegisterCreatorRequest,
  AdminRegisterCreatorResponse,
  FirebaseCreatorLookupResponse,
} from '../molecules/creator-manual-registration/creator-registration.types';
import { CreatorResponseDto } from '@/app/common/general-types/creators.dto';

export interface AdminUpdateCreatorEmailResponse {
  creator: CreatorResponseDto;
  firebaseEmail: string;
  previousEmail?: string;
}

export interface AdminSendPasswordResetResponse {
  email: string;
  sent: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AdminCreatorRegistrationService {
  private http = inject(HttpClient);
  private readonly base = `${environment.shout_api.url}/creators/admin`;

  lookupFirebase(uid: string): Observable<FirebaseCreatorLookupResponse> {
    return this.http.get<FirebaseCreatorLookupResponse>(`${this.base}/firebase-lookup/${encodeURIComponent(uid)}`);
  }

  register(body: AdminRegisterCreatorRequest): Observable<AdminRegisterCreatorResponse> {
    return this.http.post<AdminRegisterCreatorResponse>(`${this.base}/register`, body);
  }

  updateEmail(uid: string, email: string): Observable<AdminUpdateCreatorEmailResponse> {
    return this.http.post<AdminUpdateCreatorEmailResponse>(`${this.base}/update-email`, { uid, email });
  }

  sendPasswordReset(uid: string): Observable<AdminSendPasswordResetResponse> {
    return this.http.post<AdminSendPasswordResetResponse>(
      `${this.base}/send-password-reset/${encodeURIComponent(uid)}`,
      {},
    );
  }
}
